import React from 'react'
import CapturingSuccessStories from './capturing-success-stories/Capturing_Success_Stories'
import Free_Consultation from '../home/free-consultation/Free_Consultation'

function Gallery() {
  return (
    <>
      <CapturingSuccessStories/>
      <Free_Consultation/>
      </>
 

  )
}

export default Gallery